const description = 'Ottimizza il Tuo Business con il Nuovo Portale Esercenti UniCredit powered by Nexi'

function structuredData(applicationUrl, pathname = '/') {
  const siteUrl = new URL('/', applicationUrl).href
  const publisher = {
    '@type': 'Organization',
    '@id': 'https://www.unicredit.it/#organization',
    name: 'UniCredit',
    url: 'https://www.unicredit.it/'
  }
  const provider = {
    '@type': 'Organization',
    '@id': 'https://www.nexi.it/#organization',
    name: 'Nexi Payments S.p.A.',
    url: 'https://www.nexi.it/'
  }
  const website = {
    '@type': 'WebSite',
    '@id': `${siteUrl}#website`,
    url: siteUrl,
    name: 'Nuovo Portale Esercenti UniCredit',
    alternateName: ['UniCredit', 'Unicredit Nuovo Portale Esercenti', 'Portale Esercenti UniCredit']
  }
  if (pathname === '/') {
    return {
      '@context': 'https://schema.org',
      ...website,
      publisher: { ...publisher, sameAs: ['https://it.wikipedia.org/wiki/UniCredit'] },
      provider
    }
  }
  const loginUrl = new URL('/login', siteUrl).href
  return {
    '@context': 'https://schema.org',
    '@graph': [
      { ...website, publisher: { '@id': publisher['@id'] }, provider: { '@id': provider['@id'] } },
      {
        '@type': 'WebPage',
        '@id': `${loginUrl}#webpage`,
        url: loginUrl,
        name: 'Login - Nuovo Portale Esercenti UniCredit',
        isPartOf: { '@id': website['@id'] }
      },
      publisher,
      provider
    ]
  }
}

module.exports = { description, structuredData }
